<script type="text/ecmascript-6">
import { mapGetters } from "vuex";
import GeneralMixin from "JS/mixins/campaign/general";
import SocialShareMixin from "JS/mixins/campaign/social-share";
import { SlideXTransition } from "JS/transitions/transitions";

export default {
  name: "ThankYou",
  components: {
    SlideXTransition
  },
  mixins: [GeneralMixin, SocialShareMixin],
  props: {
    advancedAccessibility: {
      type: Boolean,
      default: false
    },
    advocateCampaignShareUrl: {
      type: Boolean,
      default: false
    },
    campaignRestrictedMessage: {
      required: true,
      type: Object
    },
    cardProgressLabels: {
      required: true,
      type: Object
    },
    progressBarColor: {
      default: "#229e3d",
      type: String
    },
    returnAdvocateMessage: {
      type: String,
      default: ""
    },
    showProgressCounter: {
      type: Boolean,
      default: true
    },
    thankYouImage: {
      required: false,
      type: String,
      default: ""
    },
    thankYouMessage: {
      required: true,
      type: String,
      default: "Thank you"
    }
  },
  computed: {
    ...mapGetters({
      advocateGoalCounts: "campaign/advocateGoalCounts"
    }),
    allActionsAlreadyTaken() {
      return this.$store.getters["navigation/allActionsAlreadyTaken"];
    },
    campaignRestrictionsError() {
      return this.$store.getters["navigation/campaignRestrictionsError"];
    },
    displayProgressPin() {
      // don't show the pin for the last percent
      return this.minProgressPercent < 99;
    },
    displayProgressPinLabel() {
      const progressPercent = this.minProgressPercent;
      return progressPercent > 50 && progressPercent < 100;
    },
    minProgressPercent() {
      const { completeCount, percentComplete } = this.advocateGoalCounts;

      // ensure there is enough space in the progress bar by padding it for # of digits
      const completeDigitLength = completeCount.toString().replace(",", "")
        .length;
      let minPercent = completeDigitLength * 5;

      // don't go below 8 percent
      if (minPercent < 8) {
        minPercent = 8;
      }

      return percentComplete < minPercent ? minPercent : percentComplete;
    },
    progressPinPositionStyles() {
      const leftPos = `${this.minProgressPercent}%`;

      return `left: ${leftPos}`;
    },
    progressBarStyles() {
      const leftPos = `${this.minProgressPercent}%`;

      return {
        backgroundColor: this.progressBarColor,
        width: leftPos
      };
    },
    shareMessageTag() {
      return this.advancedAccessibility ? "h3" : "span";
    }
  },
  methods: {
    shareOptionsButtonClass(shareOption) {
      return shareOption.class === "network-twitter"
        ? "btn--twitter"
        : "btn--facebook";
    }
  }
};
</script>
